import { useParams } from "react-router-dom";
import { TableRowActionLink } from "~components/DataTable/components/TableRowActionLink/TableRowActionLink.tsx";

type Props = {
  leaderCriteriaId: string;
};

export const LeaderCriteriaRulesAction = ({ leaderCriteriaId }: Props) => {
  const { customerId, sport, organizationId } = useParams();

  return (
    <TableRowActionLink
      to={`/${customerId}/admin/${sport}/${organizationId}/leaders-qualification/${leaderCriteriaId}/qualifiers`}
      icon={<i className="fas fa-list-check mr-2" />}
      linkLabelIntl={"rules"}
    />
  );
};
